// utils/chatContext.js
//
// Reconstructed: this file was imported by context/NotificationProvider.js
// (CHAT_CONTEXT_TYPES, escapeXmlAttribute, normalizeChatContext) but never
// actually existed anywhere in git history on any branch -- a pre-existing
// gap, unrelated to whatever else landed in this merge, just newly tripped
// over because this is apparently the first production build to actually
// bundle NotificationProvider.js's import graph.
//
// The five CHAT_CONTEXT_TYPES values and normalizeChatContext's contract
// aren't guessed: every real construction site across the app already sets
// `source_type` to one of these exact lowercase strings before the payload
// ever reaches NotificationProvider -- see ChangeRequestProvider.js,
// Ui.js, RightSideActionTracker.jsx, EmailModal.jsx,
// GanttDetailPanel.jsx/InsightsGantt.test.jsx, MeetingDetailModal.jsx.
// NotificationProvider's own comment ("All workspace entry points use the
// same shape before serialization") matches: there is exactly one live
// caller of createNewTaskForNotification (Ui.js), and its payload already
// carries a correct source_type by the time it gets here.

export const CHAT_CONTEXT_TYPES = {
  LISTENER: 'listener',
  MEETING: 'meeting',
  CHANGE_REQUEST: 'change_request',
  DELIVERABLE: 'deliverable',
  MAIL: 'mail',
};

// Standard XML attribute-value escaping. Used to interpolate arbitrary
// user/notification data into hand-built `<event attr="...">` tags before
// sending them to chat as context -- an unescaped `"` or `<` in, say, an
// email subject would break out of the attribute or the tag entirely.
export function escapeXmlAttribute(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

// Deliberately a thin, defensive pass-through rather than an inference
// engine: every real caller already builds a correctly-shaped payload with
// `source_type` set (see the file-level comment above), so there is no
// evidence anywhere in the codebase of a "raw" shape this needs to
// translate. Shallow-cloning (instead of returning the same reference)
// just avoids the caller's React state object being mutated in place by
// anything downstream, same reasoning as any other reducer/setState value.
export function normalizeChatContext(payload) {
  if (!payload || typeof payload !== 'object') return payload;
  return { ...payload };
}
